import RandingStyle20 from "../../randing/RandingStyle20";

function Randing203({ urlCode, urlCodeSettingId, apiUrl }) {
  return (
    <RandingStyle20
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      totalStep="3"
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/203/1-1.jpg`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/203/2-1.jpg`}
      img3Path={`${process.env.REACT_APP_CDN_BASE}/images/203/3-1.jpg`}
      qOptionColor="blue"
      qTitleColor="#204cec"
      formFieldColor="white"
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/blue/applyButton2.png`}
      companyName="본원"
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/ggul.jpg`}
      randingNumber="203"
      apiUrl={apiUrl}
    />
  );
}

export default Randing203;
